export const WalletTransactionStatus = {
  PROCESSING: "processing",
  SETTLED: "settled",
  RETURNED: "returned",
} as const;
export type WalletTransactionStatus =
  (typeof WalletTransactionStatus)[keyof typeof WalletTransactionStatus];
